import React, { useEffect, useMemo, useState } from "react";
import { PageTitle } from "src/shared/PageTitle";
import { useUser } from "src/shared/context/UserContext";
import { useSearch } from "../../../components/SearchContext";
import useCategory from "../../../hooks/useCategory";
import LoadingScreen from "../../../../../shared/components/LoadingScreen";
import { CategoryV2 } from "src/shared/types";
import { CategoryRow } from "../settingInterface";
import CategoryActions from "./CategoryActions";
import CategoryTable from "./CategoryTable";
import AddEditCategory from "./AddEditCategory";
import DeleteConfirmModal from "./DeleteConfirmModal";

const Category: React.FC = () => {
  const [addOpen, setAddOpen] = useState(false);
  const [editData, setEditData] = useState<CategoryV2>();
  const [deleteList, setDeleteList] = useState<CategoryV2[] | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showDeleted, setShowDeleted] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [field, setField] = useState("");
  const [orderby, setOrderBy] = useState("");

  const { searchTerm } = useSearch();
  const { userConfigration } = useUser();
  const { category, loading, categoryPage, DeleteCategory } = useCategory(
    refreshTrigger, showDeleted, page + 1, rowsPerPage, searchTerm, field, orderby,
  );

  useEffect(() => { setRowsPerPage(userConfigration?.tableDefaultSize || 10); }, [userConfigration]);
  useEffect(() => { setDeleteList(null); }, [category]);

  const refresh = () => setRefreshTrigger((p) => !p);

  const tableData: CategoryRow[] = useMemo(
    () => category.map((cat, i) => ({
      "S.No": page * rowsPerPage + i + 1,
      id: cat._id.$oid,
      CategoryName: cat.name,
      secondName: cat.secondName || "",
      product_count: cat.productCount,
    })),
    [category, page, rowsPerPage],
  );

  const closeModal = () => { setAddOpen(false); setEditData(undefined); refresh(); };

  if (loading || isLoading) return <LoadingScreen />;

  return (
    <div className="w-full h-full flex flex-col overflow-auto justify-start m-1 items-center bg-white rounded-2xl shadow">
      <PageTitle title="- Settings - Category" />
      <CategoryActions showDeleted={showDeleted} onShowDeletedChange={setShowDeleted} onAdd={() => setAddOpen(true)} onRefresh={refresh} setLoading={setIsLoading} />
      <CategoryTable
        data={tableData} totalRecords={categoryPage?.totalRecords || 0}
        page={page} rowsPerPage={rowsPerPage} showDeleted={showDeleted}
        onDelete={(ids) => setDeleteList(category.filter((c) => ids.includes(c._id.$oid)))}
        onEdit={(id) => setEditData(category.find((c) => c._id.$oid === id))}
        onPageChange={(_, p) => setPage(p)}
        onRowsChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
        onSort={({ field, orderby }) => { setField(field); setOrderBy(orderby); }}
      />
      {(addOpen || editData) && <AddEditCategory isOpen={addOpen || !!editData} editData={editData} close={closeModal} loading={setIsLoading} />}
      <DeleteConfirmModal list={deleteList} onClose={() => setDeleteList(null)} onConfirm={() => { if (deleteList) DeleteCategory(deleteList.map((c) => c._id.$oid)); }} />
    </div>
  );
};

export default Category;